<div
  class="navbar-area"
  [class.scrolled]="isScrolled"
  [class.hidden]="isHidden"
>
    <div class="container-fluid">
        <nav class="navbar navbar-expand-lg navbar-light" [class.active]="classApplied">
            <a class="navbar-brand" routerLink="/" *ngIf="data">
                <!-- CRITICAL: Add explicit dimensions to prevent layout shift -->
                <img src="../../../../assets/images/afrotech-logo-smallest.png" 
                     alt="AfroTech Hub logo"
                     width="120" 
                     height="40"
                     loading="eager">
            </a>
            <button class="navbar-toggler" type="button" (click)="toggleClass()">
                <span class="burger-menu">
                    <span class="top-bar"></span>
                    <span class="middle-bar"></span>
                    <span class="bottom-bar"></span>
                </span>
            </button>
            <div class="collapse navbar-collapse">
                <ul class="navbar-nav" *ngIf="data">
                    <li class="nav-item" *ngFor="let item of data">
  
                        <!-- Si menuLink existe, on utilise un lien -->
                        <a
                            *ngIf="item.attributes.menuLink"
                            [routerLink]="item.attributes.menuLink"
                            [ngClass]="{
                                'nav-link': true,
                                'dropdown-toggle': item.attributes.dropdowns?.length > 0,
                            }"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                        >
                            {{ item.attributes.menuName }}
                        </a>
                      
                        <!-- Sinon, on utilise un span -->
                        <span *ngIf="!item.attributes.menuLink"
                              [class]="item.attributes.dropdowns?.length > 0 ? 'nav-link rubrique-toggle' : 'nav-link'"
                              style="cursor: default;">
                          {{ item.attributes.menuName }}
                        </span>
                      
                        <!-- DROPDOWN MENUS -->
                        <ng-container *ngIf="item.attributes.dropdowns?.length > 0">
                          <ul class="dropdown-menu">
                            <li class="nav-item" *ngFor="let dropdownItem of item.attributes.dropdowns">
                                <!-- Si le menu parent est "Toutes les actualités", on utilise les tags -->
                                <a
                                    *ngIf="item.attributes.menuName === 'Toutes les actualités'"
                                    [routerLink]="['/news']"
                                    [queryParams]="{ tag: getTagFromLink(dropdownItem.menuLink) }"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: false }"
                                    class="nav-link"
                                >
                                    {{ dropdownItem.menuName }}
                                </a>
                                <!-- Sinon, on garde le lien normal -->
                                <a
                                    *ngIf="item.attributes.menuName !== 'Toutes les actualités'"
                                    [routerLink]="dropdownItem.menuLink"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    class="nav-link"
                                    >
                                    {{ dropdownItem.menuName }}
                                </a>
                            </li>
                          </ul>
                        </ng-container>
                      </li>                      
                </ul>
                <ul class="navbar-nav for-responsive" *ngIf="data">
                    <li class="nav-item" *ngFor="let item of data">
                        <!-- Si le menu a des sous-menus -->
                        <!-- Cas spécial pour "Toutes les actualités" -->
                        <div
                            *ngIf="item.attributes.menuName === 'Toutes les actualités'"
                            class="d-flex align-items-center"
                        >
                            <a
                                [routerLink]="['/news']"
                                class="nav-link"
                                (click)="toggleClass()"
                            >
                                {{ item.attributes.menuName }}
                            </a>
                            <span
                                class="dropdown-arrow"
                                (click)="toggleDropdown(item.attributes.menuName)"
                                [class.open]="dropdownOpenMap[item.attributes.menuName]"
                            >
                            ▾
                            </span>
                        </div>

                        <!-- Cas normal pour les autres menus avec dropdown -->
                        <div
                        *ngIf="item.attributes.dropdowns?.length > 0 && item.attributes.menuName !== 'Toutes les actualités'"
                        class="nav-link dropdown-toggle"
                        (click)="toggleDropdown(item.attributes.menuName)"
                        >
                        {{ item.attributes.menuName }}
                        <span class="dropdown-arrow" [class.open]="dropdownOpenMap[item.attributes.menuName]">▾</span>
                        </div>

                      
                        <!-- Sinon, c'est juste un lien classique -->
                        <a
                          *ngIf="!item.attributes.dropdowns?.length"
                          [routerLink]="item.attributes.menuLink"
                          class="nav-link"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }"
                          (click)="toggleClass()"
                        >
                          {{ item.attributes.menuName }}
                        </a>
                      
                        <!-- Dropdown menu -->
                        <ul
                          class="dropdown-menu"
                          *ngIf="dropdownOpenMap[item.attributes.menuName] && item.attributes.dropdowns?.length > 0"
                        >
                          <li class="nav-item" *ngFor="let dropdownItem of item.attributes.dropdowns">
                            <a
                              *ngIf="item.attributes.menuName === 'Toutes les actualités'"
                              [routerLink]="['/news']"
                              [queryParams]="{ tag: getTagFromLink(dropdownItem.menuLink) }"
                              routerLinkActive="active"
                              [routerLinkActiveOptions]="{ exact: false }"
                              class="nav-link"
                              (click)="toggleClass()"
                            >
                              {{ dropdownItem.menuName }}
                            </a>
                            <a
                              *ngIf="item.attributes.menuName !== 'Toutes les actualités'"
                              [routerLink]="dropdownItem.menuLink"
                              routerLinkActive="active"
                              [routerLinkActiveOptions]="{ exact: true }"
                              class="nav-link"
                              (click)="toggleClass()"
                            >
                              {{ dropdownItem.menuName }}
                            </a>
                          </li>
                        </ul>
                      </li>                      
                </ul>
                <div class="others-options d-flex align-items-center pt-1">
                    <div class="option-item" *ngIf="!isLoggedIn">
                        <div class="login-icon">
                            <a routerLink="/sign-in" (click)="toggleClass()">
                                <i class="ri-login-box-line"></i>
                            </a>
                        </div>
                    </div>
                    <div class="option-item" *ngIf="isLoggedIn">
                        <div class="login-icon" title="Logout">
                            <a
                                (click)="logOutUser(); toggleClass()"
                            >
                                <i class="ri-logout-box-line"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</div>